module.exports = __webpack_public_path__ + "static/media/logo.b3e8039b.png";